// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3J-Hs","infoBtn":"quickbooks_infoBtn__37DbF","formBox":"quickbooks_formBox__3J6o3","formFooter":"quickbooks_formFooter__3c_TJ"};